import React from 'react';

import classNames from 'classnames';

import { Checkbox } from '@shared/ui';

import cls from './DocumentCheckboxList.module.css';
import { useDocumentCheckboxList } from './useDocumentCheckboxList';
import { Icon } from '../../../../../../components/newUI/Icon/Icon';
import { DashboardEstimate } from '../../../../types/dashboardInformation';

interface DocumentCheckboxListProps {
    classes?: string;
    estimates: DashboardEstimate[];
    selectedEstimates: { [key: number]: boolean };
    handleCheckboxClick: (id: number) => void;
}

export const DocumentCheckboxList = ({
    classes,
    estimates,
    selectedEstimates,
    handleCheckboxClick,
}: DocumentCheckboxListProps) => (
    <div className={classNames(cls.DocumentCheckboxList, classes)}>
        {estimates.map((estimate) => (
            <Checkbox
                title=""
                isActive={selectedEstimates[estimate.id]}
                onClick={() => handleCheckboxClick(estimate.id)}
                key={estimate.id}
            >
                <div className={cls.checkboxText}>
                    <Icon
                        iconName="circle"
                        fill={estimate.status === 'in_exploitations' ? '#28B57A' : '#9DA1AC'}
                    />
                    <span>{estimate.name}</span>
                </div>
            </Checkbox>
        ))}
    </div>
);
